import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _objectSpread from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _createForOfIteratorHelper from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchgetCommunity, repairCount, surveyCount, leaseContractCount, complaintManageCount, recodeOutCount, leaseContractCountList, houseCount, fetchNotice, deviceAlarmCount, complaintSuggestionCount, newrepairCount, activityStatistics, findEventList, findDeviceState, findDeviceSysTypeState, findRepairOrderCount, findHouseCount, findChargeCount, findChargeItemCount } from "@/api/PMS/zhlg/zhlg.js"; // import { NavbarHome } from "@/layout/components";

import { selectAreaCityNode } from "@/api/PMS/treeList/index.js";
import { mapGetters, mapState } from "vuex";
import { warrantyChart, complaintsChart, lackStatisticalChart, earlyWarningChart, workOrderFeedbackRate, workOrderStatisticalBar, sevenDaysLineChart, feeLineChart, deviceGauge } from "./components";
export default {
  name: "layout",
  components: {
    // Navbar: NavbarHome,
    warrantyChart: warrantyChart,
    complaintsChart: complaintsChart,
    lackStatisticalChart: lackStatisticalChart,
    earlyWarningChart: earlyWarningChart,
    workOrderFeedbackRate: workOrderFeedbackRate,
    workOrderStatisticalBar: workOrderStatisticalBar,
    sevenDaysLineChart: sevenDaysLineChart,
    feeLineChart: feeLineChart,
    deviceGauge: deviceGauge
  },
  data: function data() {
    return {
      buildList: [],
      userName: '',
      linkageVisible: true,
      // 社区切换参数
      listQuery: {},
      // 可租赁房源资源统计
      statisticsWarranty: {},
      // 最新满意度调查问卷
      surveyCount: [],
      // 近七天投诉统计
      complaintManageCount: [],
      // 可租赁房源资源统计
      houseCount: {
        communityCount: 0,
        contractCount: 0,
        expireContractCount: 0,
        houseCount: 0,
        inRentCount: 0,
        ownerCount: 0,
        peopleCount: 0,
        tenantCount: 0
      },
      // 应收已收欠费统计
      recodeOutCount: {},
      // 最新通知
      noticeList: [],
      // 近七天合同到期告警数
      leaseContractCount: [],
      // 近七天合同到期告警数列表
      leaseContractCountList: [],
      chartData1: [],
      lendName1: [],
      total1: [],
      chartData2: [],
      lendName2: [],
      chartData3: [],
      lendName3: [],
      total3: [],
      chartData4: [],
      lendName4: [],
      total4: 0,
      XData4: [],
      data: [],
      cascaderItem: [],
      communityIds: [],
      options: [],
      // 进度条
      customColor: "rgb(42,184,254)",
      customColor2: "rgb(245,214,0)",
      processedCount: 0,
      untreatedCount: 0,
      // 菜单过滤
      newList: [],
      defalutMenuList: [],
      //已出账单、发布公告 合同到期预警为最新通知应收已收欠费统计、最新通知、近七天合同到期预警数的更多按钮；租户管理包含可租赁房源资源统计下面三个按钮是否可跳转（子菜单，跳转菜单）
      bannerMenuIdList: [{
        name: "发布公告",
        menuId: 1318,
        isDisable: true
      }, {
        name: "已出账单",
        menuId: 1247,
        isDisable: true
      }, {
        name: "合同到期预警",
        menuId: 1322,
        isDisable: true
      }, {
        name: "资源管理-房屋",
        menuId: 1145,
        isDisable: true
      }, {
        name: "合同管理",
        menuId: 1281,
        isDisable: true
      }],
      propstree: {
        label: "name",
        value: "areaId",
        children: "pmsTree",
        multiple: true
      },
      isChoosed: "",
      pickerOptions: {
        shortcuts: [{
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      dates: undefined,
      activitydates: undefined,
      tableHeight: "34vh",
      // housingResource:[{},{}],
      customClass: 'bhxcsq-new-select',
      sevenDayLegendName: [],
      sevenDayXData: [],
      deviceAlarmCountData: [],
      complaintManageCountData: [],
      repairCountData: [],
      activityData: {
        allNum: 0,
        applyNum: 0,
        notStart: 0,
        ongong: 0,
        finished: 0
      },
      equipmentList: [],
      normalRate: 0,
      failureRate: 0,
      offlineRate: 0,
      workOrderRate: 0,
      workOrderArray: [0, 0, 0],
      workOrderTotal: 0
    };
  },
  created: function created() {
    this.chooseData("LastMonth");
    this.userName = this.$store.getters.name;

    if (this.userType === 32 || this.userType === 16) {
      this.loadMenuTree();
    } else {} // this.handleFilter()
    //收费管理、通知管理、租户管理为最新通知应收已收欠费统计、最新通知、近七天合同到期预警数父级菜单


    this.defalutMenuList = [{
      name: "收费管理",
      menuId: 1206
    }, {
      name: "通知管理",
      menuId: 1316
    }, {
      name: "租户管理",
      menuId: 1280
    }, //  可租赁房源资源统计上面三个按钮 是否可跳转
    {
      name: "资源管理",
      menuId: 1142
    }]; // if (this.userType === 32 || this.userType === 16) {
    //   this.defalutMenuList = [
    //     { name: "通知公告查看", menuId: 1316 },
    //     { name: "收费管理", menuId: 1206 },
    //     { name: "合同记录查看", menuId: 1280 },
    //     { name: "资源管理", menuId: 1142 },
    //   ];
    //   this.bannerMenuIdList = [
    //     { name: "通知公告查看", menuId: 1551, isDisable: true },
    //     { name: "已出账单查看", menuId: 1555, isDisable: true },
    //     { name: "合同记录查看", menuId: 1557, isDisable: true },
    //     { name: "资源管理-房屋", menuId: 1561, isDisable: true },
    //     // { name: "合同管理", menuId: 1557, isDisable: true },
    //   ];
    // }
    // 判断用户是否拥有跳转连接的菜单

    this.newList = [];
    console.log(this.admin_routers);
    this.getNewMenu(this.admin_routers);
    console.log(this.userType);

    var _iterator = _createForOfIteratorHelper(this.bannerMenuIdList),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var key = _step.value;
        this.menuEmpty(this.newList, key);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    console.log(this.bannerMenuIdList);
    this.handleFilter(); //this.getDistrict()
  },
  computed: _objectSpread({
    sidebar: function sidebar() {
      return this.$store.state.app.sidebar;
    }
  }, mapState({
    userType: function userType(state) {
      return state.user.userType;
    },
    admin_routers: function admin_routers(state) {
      return state.permission.adminRouters;
    } // 后端生成菜单

  })),
  methods: {
    logout: function logout() {
      var _this = this;

      this.$confirm('您确定要退出, 是否继续?', '提示').then(function () {
        _this.$store.dispatch('LogOut').then(function () {
          location.reload();
        });
      });
    },
    getFullCreeen: function getFullCreeen() {
      var element = document.documentElement;

      if (this.fullscreen) {
        this.creenClose = false;

        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        this.creenClose = true;

        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
      }

      this.fullscreen = !this.fullscreen;
    },
    manage: function manage() {
      this.$router.push({
        name: 'dashboard'
      });
    },
    getNode: function getNode(dataList) {
      var _this2 = this;

      console.log(dataList);

      if (this.userType === 32 || this.userType === 16) {
        this.listQuery.communityIds = [];

        if (dataList && dataList.length > 0) {
          dataList.forEach(function (item) {
            _this2.listQuery.communityIds.push(item[item.length - 1]);
          });
        }
      } else {}

      this.handleFilter();
    },
    // 默认选中楼宇--身份16，32物业或区域管理员时
    loadMenuTree: function loadMenuTree() {
      var _this3 = this;

      var treeQuery = {
        flag: 1
      };
      selectAreaCityNode(treeQuery).then(function (response) {
        _this3.options = response.data.data; // getNode

        var cascaderItem = [];
        console.log(_this3.options);

        if (_this3.options.length !== 0) {
          cascaderItem.push(_this3.options[0].areaId);

          if (_this3.options[0].pmsTree.length !== 0) {
            // this.cascaderItem.push(this.options[0].areaId)
            cascaderItem.push(_this3.options[0].pmsTree[0].areaId);

            if (_this3.options[0].pmsTree[0].pmsTree.length !== 0) {
              cascaderItem.push(_this3.options[0].pmsTree[0].pmsTree[0].areaId);

              if (_this3.options[0].pmsTree[0].pmsTree[0].pmsTree !== 0) {
                cascaderItem.push(_this3.options[0].pmsTree[0].pmsTree[0].pmsTree[0].areaId);
              }
            }
          }
        }

        _this3.cascaderItem.push(cascaderItem);

        _this3.getNode(_this3.cascaderItem); // this.handleFilter();

      });
    },
    norma: function norma(ids, childrens) {
      // console.log('路径', childrens)
      for (var i = 0; i < childrens.length; i++) {
        if (ids === childrens[i].menuId) {
          this.newList.push({
            children: childrens[i].children,
            path: childrens[i].path,
            menuId: childrens[i].menuId,
            menuUpId: childrens[i].menuUpId,
            meta: childrens[i].meta,
            name: childrens[i].name
          });
        }
      }
    },
    //  默认选择搜索时间 今日 近一周 近一月
    chooseData: function chooseData(data) {
      var date = data;

      if (date === "data") {
        this.isChoosed = "data";
        this.dates = [new Date(), new Date()];
        this.activitydates = [new Date(), new Date()];
      } else if (date === "week") {
        this.isChoosed = "week";
        var now = new Date(); // 获取当前周的第一天

        var start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - (now.getDay() + 6) % 7);
        console.log(new Date().getDay(), now.getDay(), now.getDate()); // 获取本周的最后一天

        var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() - (now.getDay() + 6) % 7 + 6);
        start.setTime(start.getTime());
        this.dates = [start, end];
        this.activitydates = [start, end];
      } else if (date === "month") {
        this.isChoosed = "month";

        var _now = new Date(); // 获取当前月的第一天


        var _start = new Date(_now.getFullYear(), _now.getMonth(), 1);

        var _end = new Date(_now.getFullYear(), _now.getMonth() + 1, 0);

        _start.setTime(_start.getTime());

        _end.setTime(_end.getTime());

        this.dates = [_start, _end];
        this.activitydates = [_start, _end];
      } else if (date === "year") {
        this.isChoosed = "year";

        var _now2 = new Date(); // 获取当前月的第一天


        var _start2 = new Date(_now2.getFullYear(), 0, 1);

        var _end2 = new Date(_now2.getFullYear(), 12, 0);

        _start2.setTime(_start2.getTime());

        _end2.setTime(_end2.getTime());

        this.dates = [_start2, _end2];
        this.activitydates = [_start2, _end2];
      } else if (data === 'LastMonth') {
        // 获取上个月第一天
        var firstDayOfLastMonth = new Date();
        firstDayOfLastMonth.setMonth(firstDayOfLastMonth.getMonth() - 1);
        firstDayOfLastMonth.setDate(1); // 获取上个月最后一天

        var lastDayOfLastMonth = new Date(firstDayOfLastMonth);
        lastDayOfLastMonth.setMonth(lastDayOfLastMonth.getMonth() + 1);
        lastDayOfLastMonth.setDate(0); // 格式化日期字符串

        var dateFormat = function dateFormat(date) {
          return "".concat(date.getFullYear(), "-").concat((date.getMonth() + 1).toString().padStart(2, '0'), "-").concat(date.getDate().toString().padStart(2, '0'));
        };

        var _start3 = dateFormat(firstDayOfLastMonth);

        var _end3 = dateFormat(lastDayOfLastMonth);

        this.dates = [_start3, _end3];
        this.activitydates = [_start3, _end3];
      }
    },
    lackChooseData: function lackChooseData(value) {
      // console.log(value)
      this.getRecodeOutCount();
    },
    // getNewMenu menuEmpty handleMenuSelect menuFormat 用于判断用户是否拥有该跳转连接菜单
    getNewMenu: function getNewMenu(meanuList) {
      for (var i = 0; i < this.defalutMenuList.length; i++) {
        if (meanuList == null) {
          return null;
        }

        for (var j = 0; j < meanuList.length; j++) {
          if (meanuList[j].menuId) {
            if (this.defalutMenuList[i].menuId === meanuList[j].menuId) {
              this.newList.push({
                children: meanuList[j].children,
                path: meanuList[j].path,
                menuId: meanuList[j].menuId,
                menuUpId: meanuList[j].menuUpId,
                meta: meanuList[j].meta,
                name: meanuList[j].name
              });
            } else {
              if (meanuList[j].children) {
                this.norma(this.defalutMenuList[i].menuId, meanuList[j].children);
              }
            }
          }
        }
      }

      console.log("this.newList");
      console.log(this.newList);
      console.log("---this.newList---");
    },
    menuEmpty: function menuEmpty(route, menu) {
      var _this4 = this;

      var findMenu = [];

      if (route.length) {
        route.filter(function (item) {
          if (item.menuId === menu.menuId) {
            var index = _this4.bannerMenuIdList.findIndex(function (item) {
              return item.menuId === menu.menuId;
            });

            console.log(index, item.menuId, menu.menuId, menu, item, _this4.bannerMenuIdList);
            _this4.bannerMenuIdList[index].isDisable = false;
            return true;
          } else {
            _this4.menuEmpty(item, menu);

            return false;
          }
        });
      } else {
        if (route.children) {
          findMenu = route.children.filter(function (item) {
            if (item.menuId === menu.menuId) {
              var index = _this4.bannerMenuIdList.findIndex(function (item) {
                return item.menuId === menu.menuId;
              });

              _this4.bannerMenuIdList[index].isDisable = false;
              return true;
            } else {
              _this4.menuEmpty(item, menu);

              return false;
            }
          });
        }

        return findMenu;
      }
    },
    handleMenuSelect: function handleMenuSelect(menu, parameter) {
      // this.menuPathArr = []
      console.log(parameter);
      this.menuFormat(this.newList, menu, parameter); // 页面跳转
      //   console.log('跳转菜单', menu, 'id', menu.menuId)
      // this.$store.dispatch('ChooseRouters', menu) // 左侧sidebar 的内容部分
    },
    menuFormat: function menuFormat(route, menu, parameter) {
      var _this5 = this;

      var findMenu = [];

      if (route.length) {
        findMenu = route.filter(function (item) {
          if (item.menuId === menu.menuId) {
            return true;
          } else {
            _this5.menuFormat(item, menu, parameter);

            return false;
          }
        });
        var menuPath = "/" + findMenu[0].path;
        console.log("menuPath+++");
        console.log(menuPath, route);

        if (parameter === undefined) {
          console.log("parameter", parameter);
          this.$router.push(menuPath);
        } else {
          console.log("parameter", parameter);

          if (this.userType === 32 || this.userType === 16) {
            console.log(this.cascaderItem);
            parameter.cascaderItem = this.cascaderItem ? JSON.stringify(this.cascaderItem) : [];
          }

          this.$router.push({
            path: menuPath,
            query: parameter
          });
        }

        this.$store.commit("app/CHANGE_SIDEBAR", true);
        document.querySelector(".main-container").style.marginLeft = "210px";
        console.log("跳转菜单", menu);
        this.$store.dispatch("ChooseRouters", menu);
      } else {
        if (route.children) {
          findMenu = route.children.filter(function (item) {
            if (item.menuId === menu.menuId) {
              return true;
            } else {
              _this5.menuFormat(item, menu, parameter);

              return false;
            }
          });

          if (findMenu.length) {
            var _menuPath = route.path + "/" + findMenu[0].path;

            if (parameter === undefined) {
              console.log("parameter", parameter);
              this.$router.push(_menuPath);
            } else {
              if (this.userType === 32 || this.userType === 16) {
                console.log(JSON.stringify(this.cascaderItem));
                parameter.cascaderItem = this.cascaderItem ? JSON.stringify(this.cascaderItem) : [];
              }

              this.$router.push({
                path: _menuPath,
                query: parameter
              });
            }

            this.$store.commit("app/CHANGE_SIDEBAR", true);
            document.querySelector(".main-container").style.marginLeft = "210px";
            this.$store.dispatch("ChooseRouters", menu); // 左侧sidebar 的内容部分
          }
        }

        return findMenu;
      }
    },
    // 切换楼宇
    handleFilter: function handleFilter() {
      this.listQuery.page = 1; //this.getList();
      // this.getRepairCount();
      // this.getSurveyCount();
      // this.getComplaintManageCount();

      this.getHouseCount();
      this.getRecodeOutCount(); // this.getLeaseContractCount();
      // this.getLeaseContractCountList();

      this.sevendaydeviceAlarmCount();
      this.sevendaycomplaintSuggestionCount();
      this.sevendayrepairCount();
      this.getactivityStatistics();
      this.getEventList();
      this.getDeviceState();
      this.getDeviceTypeList();
      this.getRepairOrderCount();
      this.getChargeCount();
    },
    getDistrict: function getDistrict() {
      var _this6 = this;

      fetchgetCommunity({}).then(function (response) {
        _this6.buildList = response.data.data;
        _this6.listQuery.communityIds = [_this6.buildList[0].communityId.toString()];
        _this6.communityIds = [_this6.buildList[0].communityId.toString()];

        _this6.handleFilter();
      });
    },
    //格式化数组
    formatNum: function formatNum(num) {
      var a = parseInt(num);

      if (a >= 10000) {
        return (a / 10000).toFixed(1) + '万';
      } else {
        return a;
      }
    },
    //收费统计
    getChargeCount: function getChargeCount() {
      var _this7 = this;

      findChargeCount({}).then(function (res) {
        console.log('收费统计', res.data.data); //   chartData4: [],
        // lendName4: [],
        // total4: 0,
        // XData4: [],

        _this7.total4 = res.data.data.paidAmountAll;
        _this7.chartData4 = res.data.data.paidAmounts;
        _this7.lendName4 = res.data.data.chargeTypeName;
        var arr = res.data.data.dateTimeList;
        _this7.XData4 = arr.map(function (str) {
          return str.slice(5);
        });
      });
    },
    //报修工单统计
    getRepairOrderCount: function getRepairOrderCount() {
      var _this8 = this;

      findRepairOrderCount({}).then(function (res) {
        console.log('报修工单统计', res.data.data);
        _this8.workOrderRate = +(parseInt(res.data.data.praiseNum) / parseInt(res.data.data.alreadyNum) * 100).toFixed(1);
        _this8.workOrderArray = [res.data.data.noNum, res.data.data.waitNum, res.data.data.alreadyNum];
        _this8.workOrderTotal = res.data.data.allNum;
      });
    },
    //设备类型列表
    getDeviceTypeList: function getDeviceTypeList() {
      var _this9 = this;

      findDeviceSysTypeState({}).then(function (res) {
        console.log('设备类型列表', res.data.data);
        _this9.equipmentList = res.data.data;
      });
    },
    //设备管理-总计
    getDeviceState: function getDeviceState() {
      var _this10 = this;

      findDeviceState({}).then(function (res) {
        console.log('设备管理-总计', res.data.data);
        var allNum = res.data.data[0].allNum; //总数量

        var faultNum = res.data.data[0].faultNum; //离线

        var normalNum = res.data.data[0].normalNum; //正常

        var offnormalNum = res.data.data[0].offnormalNum; //故障

        _this10.normalRate = +(parseInt(normalNum) / parseInt(allNum) * 100).toFixed(1);
        _this10.failureRate = +(parseInt(offnormalNum) / parseInt(allNum) * 100).toFixed(1);
        _this10.offlineRate = +(parseInt(faultNum) / parseInt(allNum) * 100).toFixed(1);
      });
    },
    //事项列表
    getEventList: function getEventList() {
      var _this11 = this;

      findEventList({}).then(function (res) {
        console.log('事项列表', res.data.data);
        _this11.noticeList = res.data.data;
      });
    },
    //活动统计详情
    activitydatesChange: function activitydatesChange() {
      console.log('活动时间', this.activitydates);
      this.getactivityStatistics();
    },
    getactivityStatistics: function getactivityStatistics() {
      var _this12 = this;

      var query = {
        beginDate: this.activitydates[0],
        endDate: this.activitydates[1]
      };
      activityStatistics(query).then(function (res) {
        console.log('活动统计详情', res.data.data);
        _this12.activityData.allNum = res.data.data.allNum;
        _this12.activityData.applyNum = res.data.data.applyNum;
        _this12.activityData.notStart = res.data.data.analysisDataVos[0].num;
        _this12.activityData.ongong = res.data.data.analysisDataVos[1].num;
        _this12.activityData.finished = res.data.data.analysisDataVos[2].num;
      });
    },
    //近七天统计-设备告警
    sevendaydeviceAlarmCount: function sevendaydeviceAlarmCount() {
      var _this13 = this;

      deviceAlarmCount({}).then(function (res) {
        console.log('近七天统计-设备告警', res.data.data);
        var arr = res.data.data.dateTimeList;
        _this13.sevenDayXData = arr.map(function (str) {
          return str.slice(5);
        });
        _this13.sevenDayLegendName = res.data.data.areaNames;
        _this13.deviceAlarmCountData = res.data.data.areaCountNums;
      });
    },
    //近七天统计-投诉建议
    sevendaycomplaintSuggestionCount: function sevendaycomplaintSuggestionCount() {
      var _this14 = this;

      complaintSuggestionCount({}).then(function (res) {
        console.log('近七天统计-投诉建议', res.data.data);
        var arr = res.data.data.dateTimeList;
        _this14.sevenDayXData = arr.map(function (str) {
          return str.slice(5);
        });
        _this14.sevenDayLegendName = res.data.data.areaNames;
        _this14.complaintManageCountData = res.data.data.areaCountNums;
      });
    },
    //近七天统计-报事报修
    sevendayrepairCount: function sevendayrepairCount() {
      var _this15 = this;

      newrepairCount({}).then(function (res) {
        console.log('近七天统计-报事报修', res.data.data);
        var arr = res.data.data.dateTimeList;
        _this15.sevenDayXData = arr.map(function (str) {
          return str.slice(5);
        });
        _this15.sevenDayLegendName = res.data.data.areaNames;
        _this15.repairCountData = res.data.data.areaCountNums;
      });
    },
    // 报修统计
    getRepairCount: function getRepairCount() {
      var _this16 = this;

      repairCount(this.listQuery).then(function (res) {
        if (res.data.code === 200) {
          _this16.statisticsWarranty = res.data.data;
          _this16.chartData1 = [_this16.statisticsWarranty.processedCount, _this16.statisticsWarranty.untreatedCount];

          if (_this16.statisticsWarranty.repairCount === 0) {
            _this16.processedCount = 0;
            _this16.untreatedCount = 0;
          } else {
            _this16.processedCount = +(parseInt(_this16.statisticsWarranty.processedCount) / parseInt(_this16.statisticsWarranty.repairCount) * 100).toFixed(2); // +为了转为number，toFixed(2)得到字符串类型

            _this16.untreatedCount = +(parseInt(_this16.statisticsWarranty.untreatedCount) / parseInt(_this16.statisticsWarranty.repairCount) * 100).toFixed(2);
          }

          console.log("已处理", _this16.untreatedCount, _this16.processedCount);
          _this16.lendName1 = ["已处理", "未处理"];
          _this16.total1 = _this16.statisticsWarranty.repairCount;
        }
      });
    },
    // 最新满意度调查问卷
    getSurveyCount: function getSurveyCount() {
      var _this17 = this;

      var listQuery = this.listQuery;
      listQuery.limit = 7;
      this.surveyCount = [];
      surveyCount(listQuery).then(function (res) {
        if (res.data.code === 200) {
          // this.surveyCount = res.data.data;
          if (res.data.data.length >= 5) {
            _this17.surveyCount = res.data.data.slice(0, 5);
          } else {
            // this.surveyCount = res.data.data;
            _this17.surveyCount = [{
              surveyTitle: '123'
            }, {
              surveyTitle: '123'
            }, {
              surveyTitle: '123'
            }, {
              surveyTitle: '123'
            }, {
              surveyTitle: '123'
            }];
          }
        }
      });
    },
    // 投诉统计
    getComplaintManageCount: function getComplaintManageCount() {
      var _this18 = this;

      complaintManageCount(this.listQuery).then(function (res) {
        if (res.data.code === 200) {
          // console.log()
          _this18.complaintManageCount = res.data.data;
          _this18.chartData2 = [];
          _this18.lendName2 = []; // console.log(this.complaintManageCount)
          // console.log(this.complaintManageCount)

          _this18.complaintManageCount.forEach(function (item) {
            _this18.chartData2.push(item.totalOrder);

            _this18.lendName2.push(item.dealTime);
          });
        }
      });
    },
    // 资源统计
    getHouseCount: function getHouseCount() {
      var _this19 = this;

      findHouseCount({}).then(function (res) {
        if (res.data.code === 200) {
          console.log('资源统计', res.data.data);
          _this19.houseCount = res.data.data;
        }
      }); // houseCount(this.listQuery).then((res) => {
      //   if (res.data.code === 200) {
      //     this.houseCount = res.data.data;
      //   }
      // });
    },
    // 应收已收欠费统计
    getRecodeOutCount: function getRecodeOutCount() {
      var _this20 = this;

      var query = {
        beginDate: this.dates[0],
        endDate: this.dates[1]
      };
      findChargeItemCount(query).then(function (res) {
        if (res.data.code === 200) {
          console.log('应收已收欠费统计', res.data.data); // console.log('getRecodeOutCount',this.recodeOutCount)

          if (res.data.data === null) {
            _this20.recodeOutCount.recodeCountDetails = [];
            _this20.total3 = 0;
            _this20.lendName3 = ['实收', '欠费'];
            _this20.chartData3 = [0, 0];
          } else {
            _this20.recodeOutCount = res.data.data;
            _this20.total3 = _this20.recodeOutCount.receivableAmount;
            _this20.lendName3 = ['实收', '欠费'];
            _this20.chartData3 = [_this20.recodeOutCount.paidAmount, _this20.recodeOutCount.unpaidAmount]; //this.chartData3 = [568978, 2656556]
          }
        } else {
          _this20.recodeOutCount.recodeCountDetails = [];
          _this20.total3 = 0;
          _this20.lendName3 = ['实收', '欠费'];
          _this20.chartData3 = [0, 0];
        }
      }).catch(function (err) {
        _this20.recodeOutCount.recodeCountDetails = [];
        _this20.total3 = 0;
        _this20.lendName3 = ['实收', '欠费'];
        _this20.chartData3 = [0, 0];
      });
    },
    // 最新通知
    getList: function getList() {
      var _this21 = this;

      var listQuery = JSON.parse(JSON.stringify(this.listQuery));
      listQuery.limit = 5;
      listQuery.page = 1;
      listQuery.publishStatus = 1;
      console.log(listQuery);
      fetchNotice(listQuery).then(function (res) {
        if (res.data.code === 200) {
          _this21.noticeList = res.data.data;
        }
      });
    },
    //合同到期告警数
    getLeaseContractCount: function getLeaseContractCount() {
      var _this22 = this;

      leaseContractCount(this.listQuery).then(function (res) {
        if (res.data.code === 200) {
          _this22.leaseContractCount = res.data.data;
          _this22.chartData4 = [];
          _this22.lendName4 = [];

          _this22.leaseContractCount.forEach(function (item) {
            _this22.chartData4.push(item.totalOrder);

            _this22.lendName4.push(item.dealTime);
          }); // chartData4:[],
          // lendName4:[],

        }
      });
    },
    // 合同到期告警数列表
    getLeaseContractCountList: function getLeaseContractCountList() {
      var _this23 = this;

      var listQuery = this.listQuery;
      listQuery.page = 1;
      listQuery.limit = 7;
      leaseContractCountList(listQuery).then(function (res) {
        if (res.data.code === 200) {
          _this23.leaseContractCountList = res.data.data; // this.leaseContractCountList = [{contractNo: '13'},{contractNo: '13'},{contractNo: '13'},{contractNo: '13'},
          // {contractNo: '13'},{contractNo: '13'},{contractNo: '13'},{contractNo: '13'},{contractNo: '13'},]
        }
      });
    }
  }
};